import { useMutation } from '@tanstack/react-query';
import { ISystemJob } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IGoalsExportRequest {
	userId?: string;
	startDate?: string;
	endDate?: string;
}

/**
 * Queues a CSV export of the Goals tab. Resolves to the system job so the caller can hand it to
 * ExportConfirmationModalV2, which polls it and offers the file for download once it completes.
 */
export const useGoalsExportMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: any) => void;
	onSuccess?: (data: ISystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IGoalsExportRequest) => {
			return userSession.webServiceHelper.callAsync<ISystemJob>('userDailyActivity/export', 'POST', request);
		},
		onError,
		onSuccess,
	});
};
